import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => {
	return {
		dateTitle: {
			fontSize: 16,
			fontWeight: 500,
			marginBottom: 20
		},
		dateInputsBox: {
			display: 'flex',
			[theme.breakpoints.down('sm')]: {
				flexDirection: 'column'
			}
		},
		dateInputIcon: {
			'& .MuiIconButton-root': {
				padding: '0 !important'
			}
		},
		dateInputMargin: {
			marginRight: 10
		},
		dateInput: {
			marginTop: 0,
			[theme.breakpoints.down('sm')]: {
				marginBottom: 0
			}
		}
	};
});
